export const STATUS_LABELS = {
  pending_quote: "Awaiting Quote",
  pending_payment: "Awaiting Payment",
  quoted: "Quote Sent",
  approved: "Approved",
  alternative_requested: "Alt. Requested",
  in_production: "In Production",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
};
export const STATUS_COLORS = {
  pending_quote: "bg-amber-100 text-amber-900",
  pending_payment: "bg-amber-100 text-amber-900",
  quoted: "bg-blue-100 text-blue-900",
  approved: "bg-emerald-100 text-emerald-900",
  alternative_requested: "bg-amber-100 text-amber-900",
  in_production: "bg-emerald-100 text-emerald-900",
  shipped: "bg-indigo-100 text-indigo-900",
  delivered: "bg-neutral-200 text-neutral-700",
  cancelled: "bg-rose-100 text-rose-900",
};
export const REASON_LABEL = {
  out_of_price_range: "Out of price range",
  change_material: "Change material",
  change_design: "Change design",
  something_else: "Something else",
};
